// Lista de rutas públicas accesibles sin autenticación.
// Se mantienen los textos en las rutas en español para el público.
export const publicRoutes = [
  { path: "/", exact: true },
  { path: "/home", exact: true },
  { path: "/inicio", exact: true },
  { path: "/error", exact: true },
  { path: "/forgot-password", exact: false },
  { path: "/recuperar-contraseña", exact: false },
  { path: "/reset-password", exact: false },
  { path: "/restablecer-contraseña", exact: false },
  { path: "/signin", exact: true },
  { path: "/iniciar-sesion", exact: true },
  { path: "/signup", exact: false },
  { path: "/registrarse", exact: false },
  { path: "/registro/confirmacion", exact: true },
  { path: "/verify-account", exact: false },
  { path: "/verificar-cuenta", exact: false },
  { path: "/plans", exact: true },
  { path: "/planes", exact: true },
  { path: "/contact", exact: true },
  { path: "/contacto", exact: true },
  { path: "/terms-and-conditions", exact: true },
  { path: "/terminos-y-condiciones", exact: true },
  { path: "/refund-policy", exact: true },
  { path: "/politica-de-devoluciones", exact: true },
  { path: "/complaint-book", exact: true },
  { path: "/libro-de-reclamaciones", exact: true },
  { path: "/roadmap", exact: true },
  { path: "/hoja-de-ruta", exact: true },
];

/**
 * Verifica si la ruta dada es pública.
 *
 * @param {string} pathname - Ruta de la URL a evaluar.
 * @returns {boolean} - Verdadero si la ruta es pública, falso en caso contrario.
 */
export function isPublicRoute(pathname) {
  // Decodificar la ruta para manejar correctamente caracteres especiales.
  const decodedPath = decodeURIComponent(pathname);
  // Retorna true si alguna ruta pública coincide exactamente o es prefijo de la ruta decodificada.
  return publicRoutes.some(({ path, exact }) =>
    exact ? decodedPath === path : decodedPath.startsWith(path)
  );
}
